// Testnet: 1666700000,   Mainnet: 1666600000
export const harmonyChainID = 97;
